export function expandScientificNotation(value) {
    const str = String(value).toLowerCase()

    if (!str.includes("e")) {
        return str
    }

    const [coefficient, exponentPart] = str.split("e")
    const exponent = parseInt(exponentPart, 10)

    let [integer, fraction = ""] = coefficient.split(".")

    if (exponent >= 0) {
        if (fraction.length <= exponent) {
            return (
                integer +
                fraction +
                "0".repeat(exponent - fraction.length)
            )
        }

        return (
            integer +
            fraction.slice(0, exponent) +
            "." +
            fraction.slice(exponent)
        )
    }

    return (
        "0." +
        "0".repeat(Math.abs(exponent) - 1) +
        integer +
        fraction
    )
}
